module.exports = __webpack_public_path__ + "static/media/edit-gray.6e651ffa.svg";